import React, { type ReactElement } from 'react';
import { Grid } from '@mui/material';
import Subscription from '../../components/SignUp/Subscription/Subscription';

export default function ViewSubscription(): ReactElement {
  return (
    <Grid container justifyContent="center" minHeight="100vh" py={4}>
      <Grid item xs={12} maxWidth="1200px">
        <Subscription isUpdatable={false} viewOnly />
      </Grid>
    </Grid>
  );
}
